<template> 
  <el-form ref="baseForm" label-width="100px" class="dialog-from flex" :rules="rules" :model="fromData">
    <el-form-item class="item" label="物料组编码：" prop="materialGroup">
      <el-input type="text" placeholder="请输入" v-model="fromData.materialGroup"></el-input>
    </el-form-item>

    <el-form-item class="item" label="物料组描述：" prop="materialGroupDesc">
      <el-input type="text" placeholder="请输入" v-model="fromData.materialGroupDesc"></el-input>
    </el-form-item>
  </el-form>
</template>
 
<script>

export default {
  components: {},
  props: {
    fromData: Object
  },
  data() {
    return {
      textarea: "",
      rules: {
        // tenantCode: [
        //   {
        //     required: true,
        //     message: "请输入租户代码",
        //     trigger: "blur"
        //   }
        // ],
        // tenantDesc: [
        //   {
        //     required: true,
        //     message: "请输入租户名",
        //     trigger: "blur"
        //   }
        // ],
        // legalPerson: [
        //   {
        //     required: true,
        //     message: "请输入法定人",
        //     trigger: "blur"
        //   }
        // ]
      }
    };
  },
  created() {},
  methods: {
    validataForm() {
      this.$refs["baseForm"].validate(vaild => {
        this.fromData.regRes = vaild;
      });
    }
  }
};
</script>

<style>
</style>
